import React, { useEffect, useState } from "react";
import { axiosInstance } from "../helper/axiosInstance";

const emptyForm = {
    name_en: "", name_ru: "", name_hy: "",
    link: "",
    status: 1,
};

function UsefulLinksAdmin() {
    const [items, setItems] = useState([]);
    const [form, setForm] = useState(emptyForm);
    const [editId, setEditId] = useState(null);
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState("");

    const fetchItems = () => {
        axiosInstance.get("/useful-links").then((res) => setItems(res.data));
    };

    useEffect(() => { fetchItems(); }, []);

    const handleInput = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setMessage("");
        try {
            if (editId) {
                await axiosInstance.put(`/useful-links/${editId}`, form);
                setMessage("Updated successfully.");
            } else {
                await axiosInstance.post("/useful-links", form);
                setMessage("Added successfully.");
            }
            setForm(emptyForm);
            setEditId(null);
            fetchItems();
        } catch {
            setMessage("Error saving.");
        } finally {
            setLoading(false);
        }
    };

    const handleEdit = (item) => {
        setEditId(item.id);
        setForm({
            name_en: item.name_en || "",
            name_ru: item.name_ru || "",
            name_hy: item.name_hy || "",
            link: item.link || "",
            status: item.status,
        });
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    const handleDelete = async (id) => {
        if (!window.confirm("Delete this item?")) return;
        await axiosInstance.delete(`/useful-links/${id}`);
        fetchItems();
    };

    const handleCancel = () => { setForm(emptyForm); setEditId(null); setMessage(""); };

    return (
        <div style={{ padding: 32, fontFamily: "sans-serif" }}>
            <h2>Օգտակար հղումներ / Useful Links</h2>

            <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: 12, maxWidth: 500, marginBottom: 40 }}>
                <h3>{editId ? "Edit" : "Add New"}</h3>
                <input name="name_hy" placeholder="Name (HY)" value={form.name_hy} onChange={handleInput} required />
                <input name="name_en" placeholder="Name (EN)" value={form.name_en} onChange={handleInput} />
                <input name="name_ru" placeholder="Name (RU)" value={form.name_ru} onChange={handleInput} />
                <input name="link" placeholder="URL (https://...)" value={form.link} onChange={handleInput} required />
                <label>
                    Status:{" "}
                    <select name="status" value={form.status} onChange={handleInput}>
                        <option value={1}>Active</option>
                        <option value={0}>Inactive</option>
                    </select>
                </label>
                <div style={{ display: "flex", gap: 8 }}>
                    <button type="submit" disabled={loading}>{editId ? "Update" : "Add"}</button>
                    {editId && <button type="button" onClick={handleCancel}>Cancel</button>}
                </div>
                {message && <p>{message}</p>}
            </form>

            <h3>All Items ({items.length})</h3>
            <table border="1" cellPadding="8" style={{ borderCollapse: "collapse", width: "100%" }}>
                <thead>
                    <tr>
                        <th>ID</th><th>Name HY</th><th>Name EN</th><th>Name RU</th><th>Link</th><th>Status</th><th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {items.map((item) => (
                        <tr key={item.id}>
                            <td>{item.id}</td>
                            <td>{item.name_hy}</td>
                            <td>{item.name_en}</td>
                            <td>{item.name_ru}</td>
                            <td><a href={item.link} target="_blank" rel="noreferrer">{item.link}</a></td>
                            <td>{item.status ? "Active" : "Inactive"}</td>
                            <td>
                                <button onClick={() => handleEdit(item)}>Edit</button>{" "}
                                <button onClick={() => handleDelete(item.id)}>Delete</button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

export default UsefulLinksAdmin;
